import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Pane extends Component {
    render() {
        const divStyle = {
            width:'100%'
          };
        return (
            <div style={divStyle}>
                {this.props.children}
            </div>
        );
    }
}

Pane.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired
}

export default Pane;